import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { completeSubtask } from "~/store/actions/actions.subtasks.jsx";
import { getSubtaskById } from "~/store/selectors/selector.subtasks.jsx";
import { hasLoggedUserElevatedPermissions } from "~/store/selectors/selector.users.jsx";
import SubtaskItemContainer from "../../Subtasks/SubtaskItemContainer.jsx";

export const MySubtaskContainer = ({ id, isProjectNameVisible, className, isAssigneeHidden }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const canEdit = useSelector(hasLoggedUserElevatedPermissions);

  const subtask = useSelector((state) => getSubtaskById(state, id));
  const taskId = subtask.task_id;
  const projectId = subtask.project_id;

  const [editSubtaskId, setEditSubtaskId] = useState(0);
  const handleStartEdit = useCallback(() => {
    setEditSubtaskId(id);
  }, [id]);
  const handleCancelEdit = useCallback(() => {
    setEditSubtaskId(0);
  }, []);

  const onCompleteSubtask = useCallback(() => {
    dispatch(completeSubtask(id));
  }, [dispatch, id]);

  const handleConvertToTask = useCallback(() => {
    navigate(`/projects/${projectId}/tasks/${taskId}`);
  }, [navigate, projectId, taskId]);

  return (
    <SubtaskItemContainer
      id={id}
      taskId={taskId}
      projectId={projectId}
      editMode={editSubtaskId === id}
      convertToTaskReact={handleConvertToTask}
      onStartEdit={handleStartEdit}
      onCancelEdit={handleCancelEdit}
      onComplete={onCompleteSubtask}
      canModify={canEdit}
      isAssigneeHidden={isAssigneeHidden}
      isTaskNameVisible
      isProjectNameVisible={isProjectNameVisible}
      isLink
      className={className}
    />
  );
};

MySubtaskContainer.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isProjectNameVisible: PropTypes.bool,
  isAssigneeHidden: PropTypes.bool,
  className: PropTypes.string,
};

MySubtaskContainer.defaultProps = {
  isProjectNameVisible: false,
  isAssigneeHidden: true,
};
